import { Header } from "@/components/site/Header";
import { Hero } from "@/components/site/Hero";
import { NewFeaturesSection } from "@/components/site/NewFeaturesSection";
import { ProblemSection } from "@/components/site/ProblemSection";
import { EffectsSection } from "@/components/site/EffectsSection";
import { PackagesSection } from "@/components/site/PackagesSection";
import { FullSection } from "@/components/site/FullSection";
import { HowItWorks } from "@/components/site/HowItWorks";
import { IncludedSection } from "@/components/site/IncludedSection";
import { FaqSection } from "@/components/site/FaqSection";
import { FinalCta } from "@/components/site/FinalCta";
import { Footer } from "@/components/site/Footer";

export default function Home() {
  return (
    <div className="grain min-h-screen overflow-x-hidden bg-brand-bg text-brand-text">
      <Header />
      <main>
        <Hero />
        <NewFeaturesSection />
        <ProblemSection />
        <EffectsSection />
        <PackagesSection />
        <FullSection />
        <HowItWorks />
        <IncludedSection />
        <FaqSection />
        <FinalCta />
      </main>
      <Footer />
    </div>
  );
}
